<template>
  <BaseTemplate>
    <div class="complete-user-register">
      <Title jpn="Member registration completed" />
      <div class="icon"><img src="/img/member_end.png"></div>
      <div class="description">
        <span class="text">Thank you for being a member!</span>
        <span class="text">We hope you continue to enjoy </span>
        <span class="text">your Gacha purchases!</span>
      </div>
      <div v-if="isReferralCode" class="referral_code">
        <TextBox
            class="text-box"
            inputType="text"
            :value="referralCode"
            placeholder="Referral code"
            @handleTextInput="inputReferralCode"
        />
        <ErrorMessage
          v-if="referralCodeErrorMessage"
          class="error-message"
          :message="referralCodeErrorMessage"
        />
        <BlackGradationButton class="square-button confirm-btn" text="Verify" @handleSquareBtnClick="setReferralCode" />
      </div>
      <SquareButton
        class="square-button"
        text="Home"
        @handleSquareBtnClick="goToUserLogin"
      />
    </div>
    <CommonOverlay class="overlay" v-show="isComplete">
      <CommonModal class="modal">
        <span class="close" @click="isComplete = false">&times;</span>
        <div class="completed-txt">Referral code completed</div>
        <div>
          <img src="/img/check.png" alt="">
        </div>
        <BlackGradationButton class="bay-button confirm-btn" text="Confirm" @handleSquareBtnClick="goToUserLogin" />
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import t from '@/plugins/i18n';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';

export default {
  name: 'CompleteUserRegister',
  mixins: [t],

  // beforeRouteLeave(to, from, next) {
  //   if (to.name === 'ConfirmUserRegister') {
  //     next(false);
  //   } else {
  //     next();
  //   }
  // },

  components: {
    BaseTemplate,
    Title,
    SquareButton,
    TextBox,
    ErrorMessage,
    BlackGradationButton,
    CommonOverlay,
    CommonModal,
  },

  data: () => ({
    referralCode: '',
    referralCodeErrorMessage: '',
    isReferralCode: false,
    isComplete: false,
  }),

  computed: {
    ...mapGetters({
      isRegister: 'user/isRegister',
      setReferralCodeResult: 'user/setReferralCodeResult',
    }),
  },

  watch: {
    isRegister(newVal) {
      if (newVal) {
        console.log('changeUserAddressResult', newVal);
        this.$store.dispatch('user/clearHasRegister');
        this.isReferralCode = newVal.is_user_register;
      }
    },
    setReferralCodeResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.isComplete = true;
        } else {
          const {
            referral_code: referralCode,
          } = newVal.errors;
          this.referralCodeErrorMessage = referralCode ? referralCode[0] : '';
        }
      }
    },
  },

  created() {
    this.$store.dispatch('user/hasRegister');
  },

  methods: {
    goToUserLogin() {
      this.$store.dispatch('user/deleteIsUserRegister');
      this.$router.push('/');
    },
    inputReferralCode(referralCode) {
      this.referralCode = referralCode;
    },
    setReferralCode() {
      if (this.referralCode === '') {
        this.referralCodeErrorMessage = 'Please enter a referral code.';
      }
      const postParams = {
        referralCode: this.referralCode,
      };
      this.$store.dispatch('user/setReferralCode', { postParams });
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-user-register{
  width: 100%;
  max-width: 1000px;
  padding: 70px 30px 0px;
  margin: 0px auto;
  text-align: center;
  @include appendMap($backgroundStyleMap);
  .icon {
    margin-top: 20px;
    img {
      width: 244px;
    }
  }
  .description{
    display: flex;
    flex-direction: column;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    height: 113px;
    margin-top: 50px;
    .text{
      font-family: $notoSans;
      font-size: 18px;
      line-height: 1.6;
      color: $white;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 0px auto 0px;
  }
}
.referral_code {
  margin: 0 0 20px 0;
  .confirm-btn {
    margin-top: 20px;
    background-color: #081b40;
  }
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;

  .modal {
    padding: 40px 28px;
    font-family: $notoSans;
    color: #000;
    text-align: center;
    width: 586px;

    .close {
      /* 閉じるボタンを右上に表示 */
      position: absolute;
      top: 10px;
      right: 10px;
      /* 閉じるボタンの大きさ */
      font-size: 24px;
      /* 閉じるボタンのカーソル */
      cursor: pointer;
    }
  }
  .confirm-btn {
    margin: 20px auto 0;
    background-color: #081b40;
    width: 50%;
  }
}
.completed-txt {
  margin-bottom: 20px;
}
@media screen and  (max-width: $tabletWidth) {
  .complete-user-register{
    padding: 50px 30px 20px;
    .description{
      .text {
        font-size: 16px;
      }
    }
  }
}
</style>
